var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoker2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1u9i6j5s4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5231",
    style: {
      fill: "#fff"
    },
    d: "M0 0h16v7.612H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2211"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2212",
    transform: "translate(3 11.388)",
    style: {
      clipPath: "url(#1u9i6j5s4a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 898",
    d: "M7.967 7.612A7.94 7.94 0 0 1 2.688 5.73 8.819 8.819 0 0 1 .05 1.521 1.182 1.182 0 1 1 2.315.848a5.74 5.74 0 0 0 5.652 4.4 5.69 5.69 0 0 0 5.71-4.366 1.182 1.182 0 1 1 2.284.606A8.4 8.4 0 0 1 13.3 5.752a8.157 8.157 0 0 1-5.33 1.86",
    transform: "translate(-.001)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 899",
    d: "M216.485 1.774c0 .236.008.473 0 .709-.007.166.061.222.23.219.46-.007.92-.006 1.38 0a1.2 1.2 0 0 1 1.234 1.116 1.188 1.188 0 0 1-1.129 1.187c-.451.047-.9.015-1.354.022-.36.006-.36 0-.36.357V6.59a1.2 1.2 0 0 1-2.4 0 27.14 27.14 0 0 1 0-1.276c.007-.215-.064-.29-.293-.289A12.866 12.866 0 0 1 212.344 5a1.175 1.175 0 0 1-1.093-1.167 1.184 1.184 0 0 1 1.188-1.133c.468-.012.937-.009 1.4 0 .18 0 .248-.054.244-.231-.01-.425 0-.851 0-1.276a1.2 1.2 0 0 1 2.4-.013v.591",
    transform: "translate(-197.329)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 900",
    d: "M2.844 1.759c0-.221-.005-.441 0-.662A1.15 1.15 0 0 1 4 0a1.162 1.162 0 0 1 1.238 1.073c.017.449.014.9 0 1.347-.006.212.055.3.289.286.427-.016.854-.007 1.281 0a1.193 1.193 0 0 1 1.266 1.102 1.171 1.171 0 0 1-1.132 1.2 13.944 13.944 0 0 1-1.428.019c-.2 0-.279.058-.273.258.012.425.007.851 0 1.276a1.2 1.2 0 0 1-2.4-.01c0-.425-.008-.851 0-1.276 0-.187-.069-.246-.258-.248A14.96 14.96 0 0 1 1.086 5 1.19 1.19 0 0 1 0 3.849a1.2 1.2 0 0 1 1.155-1.142c.468-.016.937-.016 1.4 0 .234.008.3-.073.288-.286s0-.441 0-.662z",
    transform: "translate(0 -.001)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 901",
    d: "M124.073 112.217a2.959 2.959 0 0 1-3.022-2.879 3.024 3.024 0 0 1 6.044 0 2.958 2.958 0 0 1-3.022 2.879",
    transform: "translate(-113.073 -100.258)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoker2);
export default __webpack_public_path__ + "static/media/joker_2.14eebae9e20485e409939333abf53b25.svg";
export { ForwardRef as ReactComponent };